import { SelectFormInput } from "components/inputs";
import {
  useContractOrderRequestSalesTerms,
  useRequestOrderFormSelectedOptions,
} from "hooks/api/requestOrder";
import useSingleOptionAsFormDefault from "hooks/useSingleOptionAsFormDefault";

const SalesTermsSelect = ({ id }: { id: string }) => {
  const selectedOptions = useRequestOrderFormSelectedOptions();

  const {
    data: salesTermsOptions,
    isInitialLoading,
    isRefetching,
  } = useContractOrderRequestSalesTerms(selectedOptions);

  useSingleOptionAsFormDefault(id, salesTermsOptions);

  const isLoading = isInitialLoading || isRefetching;

  return (
    <SelectFormInput
      id={id}
      label="Sales Terms"
      options={salesTermsOptions}
      isLoading={isLoading}
      isDisabled={isLoading || (salesTermsOptions?.length ?? 0) <= 1}
      placeholder="Select terms"
    />
  );
};

export default SalesTermsSelect;
